import getEndpointNameForMode from './utils/getEndpointNameForMode';
import PersistedAddinCommand from './schema/PersistedAddinCommand';
import persistedAddins from 'owa-addins-persistent/lib/persistedAddins';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { savePersistedAddin } from 'owa-addins-services';

export default function setPersistedAddin(
    mode: ExtensibilityModeEnum,
    persistedAddin: PersistedAddinCommand
) {
    const modeString = getEndpointNameForMode(mode);
    setPersistedAddinByModeString(modeString, persistedAddin);
}

export function setPersistedAddinByModeString(
    modeString: string,
    persistedAddin: PersistedAddinCommand
) {
    const addinId = persistedAddin ? persistedAddin.addinId : '';
    const commandId = persistedAddin ? persistedAddin.commandId : '';

    persistedAddins()[modeString] = persistedAddin || undefined;
    savePersistedAddin(modeString, addinId, commandId);
}
